<template>
  <van-popup v-model="showState" position="bottom" :style="{ height: '45%' }" :close-on-click-overlay="false" @click-overlay="changeState">
    <ul class="list-wrap">
      <li class="item" v-for=" item in dataList" @click="choseSectionItem(item)"
          :key="item.value">
        {{item.label}}
      </li>
    </ul>
  </van-popup>
</template>
<script>
  export default {
    props: {
      showState: {
        type: Boolean,
        required: true
      },
      dataList: {
        type: Array,
        required: true
      }
    },
    name: 'PopList',
    data() {
      return {
        currentState: true,
      }
    },

    methods: {
      choseSectionItem(item) {
        this.$emit('chooseItem', item)
      },
      changeState() {
        this.$emit('closePop')
      }
    }
  }
</script>
<style scoped lang="less">
  .list-wrap {
    padding: 20px 10px;
    .item {
      text-align: center;
      font-size: 32px;
      line-height: 80px;
      color: #555555;
    }
  }
</style>
